import { apiSlice } from "../../app/api/apiSlice";

export const contactApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Mutation to send contact messages down the road
    submitContactMessage: builder.mutation({
      query: (messageData) => ({
        url: "/contact",
        method: "POST",
        body: messageData,
      }),
      // Invalidates messages tag if you build an admin view later
      invalidatesTags: ["ContactMessages"],
    }),
  }),
});

export const { useSubmitContactMessageMutation } = contactApiSlice;
